import { createSelector } from "reselect";

import { PropertyFormatIdentifier } from "../../../constants/propertyFormats";
import { definitionSelectors } from "..";
import { typeSelectors } from "../types";

const getPropertyAllIds = state => {
  return definitionSelectors.getEnabledDefinitions(state).properties.allIds;
};
const getPropertiesById = state => definitionSelectors.getPropertiesById(state);

const getPropertyWithId = (state, propertyId) => definitionSelectors.getPropertiesById(state).get(propertyId);

const getOrderedProperties = createSelector(
  // Input functions
  getPropertyAllIds,
  getPropertiesById,
  // Final function
  (allPropertyIds, propertiesById) => {
    return allPropertyIds.map(id => propertiesById.get(id));
  }
);

// const getOrderedProperties = state => {
//   return getPropertyAllIds(state).map(id => definitionSelectors.getPropertiesById(state).get(id));
// };

const getOrderedPropertiesForNarrativeTypes = state => {
  const definitions = definitionSelectors.getEnabledDefinitions(state);
  return definitions.properties.allIds
    .map(id => {
      const propTypes = typeSelectors.getTypesWithPropertyAccess(state, id);
      const narrativePropType = propTypes.find(typeId => definitions.types.byId.get(typeId).canIncludeInNarrative);
      if (narrativePropType) {
        return definitionSelectors.getPropertiesById(state).get(id);
      }
      return null;
    })
    .filter(p => p);
};

const getOrderedPropertiesForTypeIds = (state, typeIdSet) => {
  const definitions = definitionSelectors.getEnabledDefinitions(state);
  return definitions.properties.allIds
    .map(id => {
      const propTypes = typeSelectors.getTypesWithPropertyAccess(state, id);
      const matchingPropType = propTypes.find(typeId => typeIdSet.has(typeId));
      if (matchingPropType) {
        return definitionSelectors.getPropertiesById(state).get(id);
      }
      return null;
    })
    .filter(p => p);
};

const isTextProperty = p =>
  p.format === PropertyFormatIdentifier.text ||
  p.format === PropertyFormatIdentifier.multitext ||
  p.format === PropertyFormatIdentifier.list;

const isBooleanProperty = p => p.format === PropertyFormatIdentifier.boolean;

const isNumericProperty = p =>
  p.format === PropertyFormatIdentifier.currency ||
  p.format === PropertyFormatIdentifier.double ||
  p.format === PropertyFormatIdentifier.integer ||
  p.format === PropertyFormatIdentifier.percentage;

const getTextProperties = state => getPropertiesById(state).filter(isTextProperty);

const getBooleanProperties = state => getPropertiesById(state).filter(isBooleanProperty);
const getNumericProperties = state => getPropertiesById(state).filter(isNumericProperty);

export default {
  getPropertyAllIds,
  getOrderedProperties,
  getOrderedPropertiesForNarrativeTypes,
  getOrderedPropertiesForTypeIds,
  getPropertiesById,
  getPropertyWithId,
  isTextProperty,
  isBooleanProperty,
  isNumericProperty,
  getTextProperties,
  getBooleanProperties,
  getNumericProperties
};
